module.exports = __webpack_public_path__ + "static/media/delevery_image2.21099138.png";